// Detect if a value is undefined, null, or NaN and return the default instead.
// If the value is a number, return the number.
export function valueOrDefault(value: number | null | undefined, defaultValue: number = 0): number {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return defaultValue
    }

    return value
}
